export const contentWidth = 9;
export const contentWidthCls = `col-md-${contentWidth}`;
